/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../services/common/http.service';
import { DataSource, ServerDataSource } from 'angular2-smart-table';

@Injectable()
export class UserRolesApi {
  private readonly apiController: string = 'users-permissions/roles';

  constructor(private api: HttpService) { }

  get rolesDataSource(): DataSource {
    return this.api.getServerDataSource(`${this.api.API_BASE_URL}/${this.apiController}`);
  }

  listAll(): Observable<any[]> {
    // The users-permissions plugin always wraps the roles list as { roles: [...] },
    // never a bare array, regardless of query params.
    return this.api.get(`${this.apiController}`).pipe(map((res: any) => res?.roles ?? res));
  }

  list(pageNumber: number = 1, pageSize: number = 10): Observable<any[]> {
    const params = new HttpParams()
      .set('pageNumber', `${pageNumber}`)
      .set('pageSize', `${pageSize}`)
      .set('populate', '*');

    return this.api.get(this.apiController, { params })
      .pipe(map((res: any) => res?.roles ?? res));
  }

  get(id: number): Observable<any> {
    return this.api.get(`${this.apiController}/${id}?populate=*`)
      // .pipe(map(data => {
      //   const picture = `${this.api.API_BASE_URL}/${this.apiController}/${data.id}/photo`;
      //   return { ...data, picture };
      // }));
  }

  add(item: any): Observable<any> {
    return this.api.post(this.apiController, item);
  }

  updateCurrent(item: any): Observable<any> {
    return this.api.put(`${this.apiController}/current?populate=*`, item);
  }

  update(item: any): Observable<any> {
    return this.api.put(`${this.apiController}/${item.id}?populate=*`, item);
  }

  delete(id: number): Observable<boolean> {
    return this.api.delete(`${this.apiController}/${id}`);
  }
}
